import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "bg-white w-full h-full sm:h-auto sm:max-w-lg sm:max-h-[90vh] sm:rounded-2xl shadow-xl flex flex-col overflow-hidden" };
const _hoisted_3 = { class: "px-5 py-4 border-b border-gray-200 flex items-start justify-between gap-3" };
const _hoisted_4 = { class: "flex items-start gap-3 min-w-0" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "min-w-0" };
const _hoisted_7 = { class: "text-xl font-bold text-gray-900 truncate" };
const _hoisted_8 = {
    key: 0,
    class: "text-sm text-gray-500 mt-0.5 line-clamp-2"
};
const _hoisted_9 = { class: "flex items-start gap-3 flex-shrink-0" };
const _hoisted_10 = { class: "flex items-baseline gap-2 whitespace-nowrap" };
const _hoisted_11 = {
    key: 0,
    class: "text-sm text-gray-400 line-through"
};
const _hoisted_12 = { class: "text-xl font-bold text-gray-900" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { class: "flex-1 overflow-y-auto px-4 py-4 space-y-3" };
const _hoisted_15 = {
    key: 0,
    class: "text-sm text-red-600"
};
const _hoisted_16 = ["role", "tabindex", "onClick", "onKeydown"];
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = {
    key: 1,
    class: "h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0"
};
const _hoisted_19 = {
    key: 2,
    class: "h-12 w-12 rounded-lg bg-gray-100 text-gray-400 flex items-center justify-center flex-shrink-0"
};
const _hoisted_20 = { class: "min-w-0 flex-1" };
const _hoisted_21 = { class: "text-xs font-medium text-gray-500" };
const _hoisted_22 = {
    key: 0,
    class: "font-semibold text-gray-900 truncate"
};
const _hoisted_23 = { class: "font-semibold text-gray-900 truncate" };
const _hoisted_24 = {
    key: 2,
    class: "font-medium text-gray-400 truncate"
};
const _hoisted_25 = {
    key: 3,
    class: "text-sm text-gray-600 mt-1 truncate"
};
const _hoisted_26 = {
    key: 4,
    class: "text-xs text-gray-400 mt-0.5"
};
const _hoisted_27 = {
    key: 5,
    class: "text-xs text-gray-400 mt-0.5"
};
const _hoisted_28 = {
    key: 3,
    class: "fas fa-chevron-right text-gray-400 text-lg flex-shrink-0",
    "aria-hidden": "true"
};
const _hoisted_29 = {
    key: 4,
    class: "fas fa-check-circle text-green-600 flex-shrink-0 mr-1"
};
const _hoisted_30 = { class: "px-4 py-3 flex justify-between gap-2 border-t border-gray-200" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = ["disabled"];
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { class: "font-bold whitespace-nowrap" };
const _hoisted_35 = { class: "bg-white w-full h-full sm:h-auto sm:max-w-md sm:max-h-[85vh] sm:rounded-2xl shadow-xl flex flex-col overflow-hidden" };
const _hoisted_36 = { class: "px-5 py-4 border-b border-gray-200 flex items-center justify-between gap-3" };
const _hoisted_37 = { class: "flex items-center gap-3 min-w-0" };
const _hoisted_38 = {
    key: 0,
    class: "h-10 w-10 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0"
};
const _hoisted_39 = { class: "text-lg font-bold text-gray-900 truncate" };
const _hoisted_40 = { class: "flex-1 overflow-y-auto px-4 py-4 space-y-2" };
const _hoisted_41 = {
    key: 0,
    class: "text-sm text-gray-500"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["src", "alt"];
const _hoisted_44 = {
    key: 1,
    class: "h-12 w-12 rounded-lg bg-gray-100 text-gray-400 flex items-center justify-center flex-shrink-0"
};
const _hoisted_45 = { class: "min-w-0 flex-1" };
const _hoisted_46 = { class: "font-semibold text-gray-900 truncate" };
const _hoisted_47 = {
    key: 0,
    class: "text-sm text-gray-500"
};
import { ref, computed, watch } from 'vue';
import ProductConfigModal from '../ProductConfigModal.vue';
import CategoryIcon from '../CategoryIcon.vue';
import { needsProductConfiguration } from '@shared/utils/productConfiguration';
// Konfigurationen je Zeile (Schlüssel = row.key).
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuConfigWizard',
    props: {
        isOpen: { type: Boolean },
        menu: {},
        products: {},
        categories: {}
    },
    emits: ["close", "complete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const rowConfigs = ref({});
        // Gewähltes (volles) Produkt je Auswahl-Zeile.
        const chosenProducts = ref({});
        const configModalOpen = ref(false);
        const configProduct = ref(null);
        const pendingRowKey = ref(null);
        const pickerRow = ref(null);
        const isSubmitting = ref(false);
        const currencyFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
        const formatPrice = (cent) => currencyFormatter.format((cent || 0) / 100);
        const idOf = (p) => String(p?._id || p?.id || '');
        const productImage = (p) => p?.image || p?.imageUrl || undefined;
        const menuImage = computed(() => props.menu?.imageUrl || props.menu?.image || undefined);
        // Referenzpreis = günstigste Einzelkauf-Option: je Sektion das günstigste wählbare
        // Produkt × Anzahl (bzw. alle festen Produkte). Dient als Streichpreis im Header.
        const referencePriceCent = computed(() => {
            const sections = props.menu?.sections || [];
            let total = 0;
            for (const section of sections) {
                const type = deriveType(section);
                const pool = itemsToProducts(section, type);
                const prices = pool.map((p) => Number(p?.priceCent) || 0).filter((n) => n > 0);
                if (!prices.length)
                    continue;
                if (type === 'fixed') {
                    total += prices.reduce((sum, x) => sum + x, 0);
                }
                else {
                    const qty = section.quantity && section.quantity > 0 ? Math.floor(section.quantity) : 1;
                    total += Math.min(...prices) * qty;
                }
            }
            return total;
        });
        const deriveType = (section) => section.selectionType || (section.includeAllFromCategory ? 'category_choice' : 'fixed');
        /** Volles Produkt (mit Größen/Zutaten) bevorzugt aus der Seiten-Produktliste auflösen. */
        const resolveFullProduct = (ref) => {
            const productId = typeof ref === 'object' && ref ? ref._id || ref.id : ref;
            if (!productId)
                return null;
            const full = props.products.find((p) => p.id === productId || p._id === productId);
            if (full)
                return full;
            return typeof ref === 'object' ? ref : null;
        };
        const itemsToProducts = (section, type) => {
            const products = (section.items || [])
                .map((it) => resolveFullProduct(it.product))
                .filter(Boolean);
            if (type === 'product_choice' || type === 'category_choice') {
                return products.filter((p) => p.available !== false && p.isVisible !== false);
            }
            return products;
        };
        const rows = computed(() => {
            const menu = props.menu;
            if (!menu)
                return [];
            const sections = [...(menu.sections || [])].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
            const out = [];
            for (const section of sections) {
                const type = deriveType(section);
                const sectionId = section._id ? String(section._id) : undefined;
                const required = section.required !== false;
                const pool = itemsToProducts(section, type);
                const baseKey = section._id || section.name;
                const sourceCategoryId = section.sourceCategoryId ? String(section.sourceCategoryId) : undefined;
                const sourceCategoryName = section.sourceCategoryName || undefined;
                if (type === 'fixed') {
                    pool.forEach((product, i) => {
                        out.push({
                            key: `${baseKey}:${i}`, sectionId, sectionName: section.name, selectionType: type,
                            required, mode: 'fixed', fixedProduct: product, pool: [product], instanceIndex: i, instanceCount: pool.length,
                            sourceCategoryId, sourceCategoryName
                        });
                    });
                }
                else {
                    const count = section.quantity && section.quantity > 0 ? Math.floor(section.quantity) : 1;
                    for (let i = 0; i < count; i++) {
                        out.push({
                            key: `${baseKey}:${i}`, sectionId, sectionName: section.name, selectionType: type,
                            required, mode: 'choice', pool, instanceIndex: i, instanceCount: count,
                            sourceCategoryId, sourceCategoryName
                        });
                    }
                }
            }
            return out;
        });
        const rowLabel = (row) => row.instanceCount > 1 ? `${row.sectionName} · ${row.instanceIndex + 1}/${row.instanceCount}` : row.sectionName;
        const rowProduct = (row) => row.mode === 'fixed' ? row.fixedProduct : chosenProducts.value[row.key] || null;
        const rowImage = (row) => productImage(rowProduct(row));
        /** Das in der Kategorie hinterlegte Icon für Kategorieauswahl-Zeilen. */
        const rowCategoryIcon = (row) => {
            if (row.selectionType !== 'category_choice')
                return null;
            const cats = props.categories || [];
            const cat = cats.find((c) => (row.sourceCategoryId && String(c.id ?? c._id) === row.sourceCategoryId) ||
                (row.sourceCategoryName && c.name === row.sourceCategoryName));
            if (!cat)
                return null;
            return { icon: cat.icon, color: cat.color };
        };
        const rowNeedsConfig = (row) => {
            const product = rowProduct(row);
            return product ? needsProductConfiguration(product) : false;
        };
        const isRowComplete = (row) => {
            if (rowConfigs.value[row.key])
                return true;
            if (row.mode === 'fixed' && !rowNeedsConfig(row))
                return true;
            if (row.mode === 'choice' && !row.required)
                return true;
            return false;
        };
        const allComplete = computed(() => rows.value.every(isRowComplete));
        // Eine Zeile ist klickbar (öffnet Auswahl- bzw. Konfig-Modal), wenn es etwas zu
        // wählen/konfigurieren gibt.
        const rowClickable = (row) => row.mode === 'choice' ? row.pool.length > 0 : rowNeedsConfig(row);
        const onRowClick = (row) => {
            if (isSubmitting.value || !rowClickable(row))
                return;
            if (row.mode === 'choice')
                openPicker(row);
            else
                openConfig(row, row.fixedProduct);
        };
        // Live-Preis: Menü-Basispreis + konfigurierte Aufpreise (Größe + Extras), client-seitig.
        // Die Seite rechnet beim Hinzufügen autoritativ neu.
        const configSurchargeCent = (cfg) => {
            if (!cfg)
                return 0;
            let surcharge = 0;
            const size = cfg.selectedSize;
            if (size)
                surcharge += Number(size.priceModifierCent ?? size.priceCent ?? 0) || 0;
            for (const extra of cfg.extras || []) {
                const e = extra;
                surcharge += Number(e.priceCent ?? (e.price != null ? e.price * 100 : 0)) || 0;
            }
            return surcharge;
        };
        const currentPriceCent = computed(() => {
            const base = props.menu?.menuPriceCent || 0;
            let surcharge = 0;
            for (const cfg of Object.values(rowConfigs.value))
                surcharge += configSurchargeCent(cfg);
            return base + surcharge;
        });
        // Solange nicht alles gewählt ist: „ab …". Wenn vollständig: finaler Preis.
        const footerPriceLabel = computed(() => allComplete.value ? formatPrice(currentPriceCent.value) : `ab ${formatPrice(currentPriceCent.value)}`);
        const removedNames = (removed) => removed.map((r) => (typeof r === 'string' ? r : r?.name || '')).filter(Boolean).join(', ');
        const rowSummary = (row) => {
            const cfg = rowConfigs.value[row.key];
            if (!cfg)
                return '';
            const parts = [];
            if (cfg.selectedSize?.name)
                parts.push(cfg.selectedSize.name);
            if (cfg.extras?.length)
                parts.push(`+${cfg.extras.length} Extra${cfg.extras.length === 1 ? '' : 's'}`);
            if (cfg.removedIngredients?.length)
                parts.push(`ohne ${removedNames(cfg.removedIngredients)}`);
            return parts.join(' · ');
        };
        // --- Speichern (sectionId direkt anhängen) ---
        const storeConfig = (row, cfg) => {
            rowConfigs.value = {
                ...rowConfigs.value,
                [row.key]: row.sectionId ? { ...cfg, sectionId: row.sectionId } : cfg
            };
        };
        const clearConfig = (row) => {
            const { [row.key]: _removed, ...rest } = rowConfigs.value;
            rowConfigs.value = rest;
        };
        const mapConfiguredToComponent = (configured) => ({
            productId: configured._id || configured.id,
            productName: configured.name,
            selectedSize: configured.selectedSize,
            extras: configured.extras,
            removedIngredients: configured.removedIngredients,
            selectedMandatoryIngredients: configured.selectedMandatoryIngredients,
            specialInstructions: configured.specialInstructions
        });
        // --- Produkt-Auswahl-Modal ---
        const openPicker = (row) => {
            if (!row.pool.length)
                return;
            pickerRow.value = row;
        };
        const closePicker = () => {
            pickerRow.value = null;
        };
        const selectPickerProduct = (product) => {
            const row = pickerRow.value;
            if (!row)
                return;
            chosenProducts.value = { ...chosenProducts.value, [row.key]: product };
            clearConfig(row);
            closePicker();
            if (needsProductConfiguration(product)) {
                openConfig(row, product);
            }
            else {
                // Ohne Konfigurationsbedarf gilt die Auswahl als erledigt.
                storeConfig(row, { productId: idOf(product), productName: product.name });
            }
        };
        // --- Produkt-Konfigurations-Modal ---
        const openConfig = (row, product) => {
            if (!product)
                return;
            pendingRowKey.value = row.key;
            configProduct.value = product;
            configModalOpen.value = true;
        };
        const onConfigModalClose = () => {
            configModalOpen.value = false;
            pendingRowKey.value = null;
        };
        const onComponentConfigured = (configured) => {
            configModalOpen.value = false;
            const key = pendingRowKey.value;
            const row = key ? rows.value.find((r) => r.key === key) : undefined;
            if (row)
                storeConfig(row, mapConfiguredToComponent(configured));
            pendingRowKey.value = null;
        };
        const finish = () => {
            const menu = props.menu;
            if (!menu || isSubmitting.value || !allComplete.value)
                return;
            isSubmitting.value = true;
            const componentConfigs = [];
            for (const row of rows.value) {
                let cfg = rowConfigs.value[row.key];
                // Feste, nicht-konfigurierbare Produkte erhalten hier ihren Snapshot.
                if (!cfg && row.mode === 'fixed' && !rowNeedsConfig(row) && row.fixedProduct) {
                    cfg = { productId: idOf(row.fixedProduct), productName: row.fixedProduct?.name };
                    if (row.sectionId)
                        cfg = { ...cfg, sectionId: row.sectionId };
                }
                if (cfg)
                    componentConfigs.push(cfg);
            }
            // Preis provisorisch (Menü-Basispreis) — die Seite rechnet autoritativ neu.
            emit('complete', {
                menu,
                componentConfigs,
                totalPrice: (menu.menuPriceCent || 0) / 100,
                totalPriceCent: menu.menuPriceCent,
                totalDepositCent: 0
            });
        };
        watch(() => props.isOpen, (open) => {
            if (open) {
                rowConfigs.value = {};
                chosenProducts.value = {};
                configModalOpen.value = false;
                configProduct.value = null;
                pendingRowKey.value = null;
                pickerRow.value = null;
                isSubmitting.value = false;
                // Auswahl-Zeilen mit genau EINEM Produkt vorab auswählen (verhält sich wie ein
                // festes Produkt: kein unnötiger 1-Treffer-Picker). Konfigurierbare Produkte
                // werden vorausgewählt (Chevron öffnet die Konfiguration), nicht-konfigurierbare
                // gelten direkt als erledigt.
                for (const row of rows.value) {
                    if (row.mode === 'choice' && row.pool.length === 1) {
                        const product = row.pool[0];
                        chosenProducts.value = { ...chosenProducts.value, [row.key]: product };
                        if (!needsProductConfiguration(product)) {
                            storeConfig(row, { productId: idOf(product), productName: product.name });
                        }
                    }
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" Menü-Modal: an <body> teleportiert, z-50 → überdeckt die sticky Webseiten-Navigation. "),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (_ctx.isOpen && _ctx.menu)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fixed inset-0 z-50 bg-black/50 flex items-stretch justify-center sm:items-center sm:p-4",
                            role: "dialog",
                            "aria-modal": "true",
                            "aria-label": `Menü „${_ctx.menu.name}“ zusammenstellen`,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (!isSubmitting.value && _ctx.$emit('close')), ["self"]))
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createCommentVNode(" Header (Bild links, ohne Schritte/Fortschritt) "),
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        (menuImage.value)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: menuImage.value,
                                                alt: _ctx.menu.name,
                                                class: "h-14 w-14 rounded-lg object-cover bg-gray-100 flex-shrink-0"
                                            }, null, 8 /* PROPS */, _hoisted_5))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.menu.name), 1 /* TEXT */),
                                            (_ctx.menu.description)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.menu.description), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createCommentVNode(" Streichpreis: günstigste Einzelkauf-Option (sofern teurer als der Menüpreis). "),
                                            (referencePriceCent.value > (_ctx.menu.menuPriceCent || 0))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(formatPrice(referencePriceCent.value)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createElementVNode("span", _hoisted_12, _toDisplayString(formatPrice(_ctx.menu.menuPriceCent)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "p-2 -mr-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md",
                                            "aria-label": "Schließen",
                                            disabled: isSubmitting.value,
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                                        }, [...(_cache[3] || (_cache[3] = [
                                                _createElementVNode("i", { class: "fas fa-times text-lg" }, null, -1 /* CACHED */)
                                            ]))], 8 /* PROPS */, _hoisted_13)
                                    ])
                                ]),
                                _createCommentVNode(" Liste aller Menü-Kategorien "),
                                _createElementVNode("div", _hoisted_14, [
                                    (!rows.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Für dieses Menü sind keine konfigurierbaren Bestandteile hinterlegt. "))
                                        : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: row.key,
                                            class: _normalizeClass(["rounded-xl border p-3 flex items-center gap-3 transition-colors", [
                                                    isRowComplete(row) ? 'border-green-200 bg-green-50/60' : 'border-gray-200',
                                                    rowClickable(row) ? 'cursor-pointer hover:border-red-300 hover:bg-gray-50' : ''
                                                ]]),
                                            role: rowClickable(row) ? 'button' : undefined,
                                            tabindex: rowClickable(row) ? 0 : undefined,
                                            onClick: ($event) => (onRowClick(row)),
                                            onKeydown: _withKeys(_withModifiers(($event) => (onRowClick(row)), ["prevent"]), ["enter"])
                                        }, [
                                            _createCommentVNode(" Icon: Produktbild → Kategorie-Icon (für Kategorieauswahl) → Platzhalter "),
                                            (rowImage(row))
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: rowImage(row),
                                                    alt: rowProduct(row)?.name || row.sectionName,
                                                    class: "h-12 w-12 rounded-lg object-cover bg-gray-100 flex-shrink-0"
                                                }, null, 8 /* PROPS */, _hoisted_17))
                                                : (rowCategoryIcon(row))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                        _createVNode(CategoryIcon, {
                                                            icon: rowCategoryIcon(row)?.icon,
                                                            color: rowCategoryIcon(row)?.color || '#6b7280',
                                                            size: "1.6rem"
                                                        }, null, 8 /* PROPS */, ["icon", "color"])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[4] || (_cache[4] = [
                                                            _createElementVNode("i", { class: "fas fa-utensils" }, null, -1 /* CACHED */)
                                                        ]))])),
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("p", _hoisted_21, _toDisplayString(rowLabel(row)), 1 /* TEXT */),
                                                _createCommentVNode(" Festes Produkt "),
                                                (row.mode === 'fixed')
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(row.fixedProduct?.name), 1 /* TEXT */))
                                                    : (chosenProducts.value[row.key])
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createCommentVNode(" Auswahl: gewähltes Produkt oder Platzhalter "),
                                                            _createElementVNode("p", _hoisted_23, _toDisplayString(chosenProducts.value[row.key]?.name), 1 /* TEXT */)
                                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_24, "Bitte wählen …")),
                                                _createCommentVNode(" Konfigurations-Zusammenfassung / Hinweise "),
                                                (rowSummary(row))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(rowSummary(row)), 1 /* TEXT */))
                                                    : (row.mode === 'fixed' && !rowNeedsConfig(row))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Im Menü enthalten "))
                                                        : (!row.required && !chosenProducts.value[row.key])
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, " Optional "))
                                                            : _createCommentVNode("v-if", true)
                                            ]),
                                            _createCommentVNode(" Pfeil (ganze Zeile ist klickbar) bzw. Haken bei fertigen festen Produkten "),
                                            (rowClickable(row))
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                                : (isRowComplete(row))
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                                                    : _createCommentVNode("v-if", true)
                                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_16));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _createCommentVNode(" Footer "),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-60",
                                        disabled: isSubmitting.value,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                                    }, " Abbrechen ", 8 /* PROPS */, _hoisted_31),
                                    (rows.value.length)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "px-4 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 disabled:opacity-60 flex items-center gap-2",
                                            disabled: !allComplete.value || isSubmitting.value,
                                            onClick: finish
                                        }, [
                                            (isSubmitting.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Wird hinzugefügt …"))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _cache[5] || (_cache[5] = _createElementVNode("span", null, "In den Warenkorb", -1 /* CACHED */)),
                                                    _createElementVNode("span", _hoisted_34, "· " + _toDisplayString(footerPriceLabel.value), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                        ], 8 /* PROPS */, _hoisted_32))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ], 8 /* PROPS */, _hoisted_1))
                        : _createCommentVNode("v-if", true)
                ])),
                _createCommentVNode(" Produkt-Auswahl-Modal (öffnet aus einer Auswahl-Zeile). Teleportiert nach dem\r\n       Menü-Modal → liegt davor; das ProductConfigModal liegt wiederum davor. "),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (pickerRow.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fixed inset-0 z-50 bg-black/50 flex items-stretch justify-center sm:items-center sm:p-4",
                            role: "dialog",
                            "aria-modal": "true",
                            onClick: _withModifiers(closePicker, ["self"])
                        }, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        (rowCategoryIcon(pickerRow.value))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                _createVNode(CategoryIcon, {
                                                    icon: rowCategoryIcon(pickerRow.value)?.icon,
                                                    color: rowCategoryIcon(pickerRow.value)?.color || '#6b7280',
                                                    size: "1.3rem"
                                                }, null, 8 /* PROPS */, ["icon", "color"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("h2", _hoisted_39, _toDisplayString(pickerRow.value.sectionName), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-2 -mr-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md",
                                        "aria-label": "Schließen",
                                        onClick: closePicker
                                    }, [...(_cache[6] || (_cache[6] = [
                                            _createElementVNode("i", { class: "fas fa-times text-lg" }, null, -1 /* CACHED */)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                    (!pickerRow.value.pool.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Aktuell sind in dieser Gruppe keine Produkte verfügbar. "))
                                        : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickerRow.value.pool, (product) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: idOf(product),
                                            type: "button",
                                            class: _normalizeClass(["w-full text-left rounded-xl border p-3 flex items-center gap-3 hover:border-red-400 hover:bg-red-50/40 transition-colors", idOf(chosenProducts.value[pickerRow.value.key]) === idOf(product) ? 'border-red-400 bg-red-50/50' : 'border-gray-200']),
                                            onClick: ($event) => (selectPickerProduct(product))
                                        }, [
                                            (productImage(product))
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: productImage(product),
                                                    alt: product.name,
                                                    class: "h-12 w-12 rounded-lg object-cover bg-gray-100 flex-shrink-0"
                                                }, null, 8 /* PROPS */, _hoisted_43))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[7] || (_cache[7] = [
                                                        _createElementVNode("i", { class: "fas fa-utensils" }, null, -1 /* CACHED */)
                                                    ]))])),
                                            _createElementVNode("div", _hoisted_45, [
                                                _createElementVNode("p", _hoisted_46, _toDisplayString(product.name), 1 /* TEXT */),
                                                (product.priceCent != null)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(formatPrice(product.priceCent)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-chevron-right text-gray-400 flex-shrink-0" }, null, -1 /* CACHED */))
                                        ], 10 /* CLASS, PROPS */, _hoisted_42));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])),
                _createCommentVNode(" ProductConfigModal teleportiert sich selbst an <body> (z-50) und liegt damit\r\n       vor Menü- und Auswahl-Modal (DOM-Reihenfolge). "),
                (configProduct.value)
                    ? (_openBlock(), _createBlock(ProductConfigModal, {
                        key: 0,
                        isOpen: configModalOpen.value,
                        product: configProduct.value,
                        "price-mode": "menu",
                        onClose: onConfigModalClose,
                        onAddToCart: onComponentConfigured
                    }, null, 8 /* PROPS */, ["isOpen", "product"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
